import { render, staticRenderFns } from "./ChargeRuleForm.vue?vue&type=template&id=3cfb4fbc&scoped=true&"
import script from "./ChargeRuleForm.vue?vue&type=script&lang=js&"
export * from "./ChargeRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfb4fbc",
  null
  
)

export default component.exports